module.exports = __webpack_public_path__ + "static/media/no-remainder.29743031.svg";